import React from "react";
import ExperienceItem from "../components/ExperienceItem";
import { experience } from "../lib/data";

function ExperienceSection() {
  return (
    <div className="flex flex-col gap-8">
      <div className="opacity-0-start animate-fade-in-d1">
        <h2 className="text-xl font-bold">Experience</h2>
      </div>

      <div>
        {experience.map((exp, i: number) => (
          <ExperienceItem
            key={i}
            role={exp.role}
            company={exp.company}
            period={exp.period}
            current={exp.current}
            points={exp.points}
            animationClass={`animate-fade-in-d${Math.min(i + 2, 5)}`}
          />
        ))}
      </div>
    </div>
  );
}

export default ExperienceSection;